$(document).ready(function(){
       $(".custom-logo").owlCarousel({
	    center: true,
        autoplay:true,
        //autoWidth: true,
		autoplayTimeout:3000,
        smartSpeed:1500,
        loop:true,
        items: 1,
        margin:10,
        responsiveClass:true,
        responsive:{
        0:{
            items:1,
            dots: false
        },
        280:{
            items:2,
            dots: false
        },
        480:{
            items:2,
            dots: false
        },
        600:{
            items:2,
            dots: false,
        },
        768 : {
          items: 3,
          dots: false,
          loop:true
        },
        1000:{
            items:4,
            dots: false,
            loop:true
        },
        1200:{
            items:6,
            dots: false,
            loop:true
        },
        1400:{
            items:8,
            dots: false,
            loop:true
        },
      }
    });
});
const swiper = new Swiper('.swiper', {
  renderBullet: function (index, className) {
    return '<span class="' + className + '">' + (index + 1) + '</span>';
  },
});